export function escapeCsvCell(value: unknown, separator: string): string {
  const str = value == null ? '' : String(value);
  if (!str) return str;
  if (str.includes(separator) || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}
